import React, { use, useState } from "react";
import {
	TextField,
	Button,
	Paper,
	Typography,
	CircularProgress,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	CssBaseline,
	Divider,
	Box,
} from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // for navigation
import axios from "../../api/axios"; // your axios instance
import { countries } from "../../data";
import { Link } from "react-router-dom";
import axiosLib from "axios";
import { jwtDecode } from "jwt-decode";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const StyledPaper = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(4),
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	maxWidth: 400,
	margin: "auto",
	borderRadius: "20px",
	boxShadow: theme.shadows[5],
	transition: "transform 0.2s",
	"&:hover": {
		transform: "scale(1.03)",
	},
}));

const LoginForm = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [selectedCountry, setSelectedCountry] = useState("");
	const [error, setError] = useState(""); // For user-visible error messages
	const [loading, setLoading] = useState(false);
	const [successMsg, setSuccessMsg] = useState("");
	const { setAuth } = useAuth();
	// const axiosPrivate = useAxiosPrivate();

	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setSuccessMsg("");

		if (!validateEmail(email)) {
			setError("Please enter a valid email address.");
			return;
		}

		setLoading(true);
		try {
			const response = await axios.post(
				"/login",
				{
					email,
					password,
				},
				{
					withCredentials: true,
				}
			);

			setSuccessMsg("Registration successful! Redirecting to login...");
			// console.log(response);

			// capture
			if (response.status === 200) {
				const { accessToken } = response?.data;

				const userData = jwtDecode(accessToken);
				const {
					id,
					plan,
					balance,
					profit,
					isRealMode,
					isDemoMode,
					recentInvestment,
					loss,
					email,
					withdrawalReq,
					depositAlert,
					isAdmin,
					isMiner1Active,
					isMiner2Active,
					isMiner3Active,
					isPlan1Active,
					isPlan2Active,
					isplan3Active,
					isplan4Active,
					isPlan5Active,
					isPlan6Active,
					isPlan7Active,
				} = userData;

				console.log(userData);
				setAuth((prev) => ({
					...prev,
					id,
					accessToken,
					plan,
					balance,
					isRealMode,
					isDemoMode,
					recentInvestment,
					email,
					profit,
					loss,
					withdrawalReq,
					depositAlert,
					isAdmin,
					isMiner1Active,
					isMiner2Active,
					isMiner3Active,
					isPlan1Active,
					isPlan2Active,
					isplan3Active,
					isplan4Active,
					isPlan5Active,
					isPlan6Active,
					isPlan7Active,
				}));

				console.log({ isAdmin });
				if (isAdmin) {
					// to admin dashboard
					setTimeout(() => {
						navigate("/admin");
					}, 1500);
				} else {
					// to user dashboard
					setTimeout(() => {
						navigate("/dashboard");
					}, 1500);
				}
			}

			// setTimeout(() => {
			// 	navigate("/en/login");
			// }, 1500);
		} catch (err) {
			// Improved error handling
			if (axiosLib.isAxiosError(err)) {
				if (err.response && err.response.data) {
					// Show server-sent error message if available
					setError(err.response.data.message || "Login failed");
				} else if (err.message) {
					// Network or other axios error
					setError(err.message);
				} else {
					setError("An unknown error occurred");
				}
			} else {
				setError("An unexpected error occurred");
			}
		} finally {
			setLoading(false);
		}
	};

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	return (
		<motion.div
			initial={{ opacity: 0, y: -30 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
			className=" my-[5rem]   w-[90%] mx-auto    ">
			<StyledPaper elevation={3}>
				<Box
					sx={{
						mb: 1,
						// textAlign: "center",
						position: "relative",
						width: "100%",
						p: 2,
						minHeight: "5rem",
						background: "linear-gradient(to top, white ,  #162027   10%)",
						borderRadius: "12px 12px 0 0",
						// borderTopRightRadius: "20px",
					}}>
					<Box>
						<Typography
							variant="h6"
							sx={{ fontWeight: "medium", color: "white" }}
							gutterBottom>
							Welcome Back!
						</Typography>
						<Divider
							sx={{
								bgcolor: "#F5F5F5",
								width: "40%",
								my: "0.5rem",
								height: "0.1rem",
							}}
						/>
						<Typography
							// variant="h6"
							sx={{
								fontWeight: "thinner",
								// my: "0.5rem",
								color: "#F5F5F5",
								fontSize: "0.8rem",
								color: "gray",
								// mb: "0.3rem",
							}}
							gutterBottom>
							Sign in to experience seamless trading.
						</Typography>
					</Box>
					{/* <Typography
						// variant="h5"
						sx={{
							fontWeight: "medium",
							color: "white",
							mb: "6rem",
							textAlign: "left",
							px: 2,
						}}
						gutterBottom>
						Sign in to experience seamless trading.
					</Typography> */}
					{/* <Typography sx={{ color: "gray", fontSize: "0.9rem", mb: 2 }}>
						Login now to see what we have for you.
					</Typography> */}
					{/* <div className="custom-shape-divider-bottom-1760350747  border-b-0  shadow-none ">
						<svg
							data-name="Layer 1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1200 120"
							preserveAspectRatio="none">
							<path
								d="M1200 0L0 0 892.25 114.72 1200 0z"
								class="shape-fill"></path>
						</svg>
					</div> */}
				</Box>
				<form onSubmit={handleLogin} style={{ width: "100%" }} noValidate>
					<Box
						sx={{
							// background: "linear-gradient(to top, white , #F5F5F5  20%)",
							border: "1px solid #F5F5F5",
							p: 2,
							borderRadius: "8px",
							mb: 1,
							display: "grid",
							gridTemplateColumns: { xm: "1fr", sm: "2fr 2fr" },
							gap: { xs: 1, sm: 2 },
						}}>
						<TextField
							label="Email"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
						<TextField
							label="Password"
							type="password"
							variant="standard"
							fullWidth
							margin="normal"
							required
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
					</Box>
					{/* <FormControl variant="outlined" fullWidth margin="normal" required>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							onChange={(e) => setSelectedCountry(e.target.value)}
							label="Country">
							{countries.map((country) => (
								<MenuItem key={country.code} value={country.name}>
									{country.name}
								</MenuItem>
							))}
						</Select>
					</FormControl> */}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						sx={{ position: "relative", bgcolor: "black" }}>
						{loading && (
							<CircularProgress
								size={24}
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
									transform: "translate(-50%, -50%)",
								}}
							/>
						)}
						{!loading && "Login"}
					</Button>
					{error && (
						<Typography color="error" align="center" sx={{ mt: 2 }}>
							{error}
						</Typography>
					)}
					{successMsg && (
						<Typography color="primary" align="center" sx={{ mt: 2 }}>
							{successMsg}
						</Typography>
					)}
				</form>
				<Typography variant="body2" align="center" sx={{ mt: 2 }}>
					Forgot password?{" "}
					<Link to="/en/forgotpassword" className="text-blue-500">
						Reset Password Now
					</Link>
				</Typography>
				<Typography variant="body2" align="center" sx={{ mt: 2 }}>
					Dont have an account?{" "}
					<Link to="/en/register" className="text-blue-500">
						Register
					</Link>
				</Typography>
			</StyledPaper>
		</motion.div>
	);
};

const theme = createTheme({
	palette: {
		primary: { main: "#1976d2" },
		secondary: { main: "#dc004e" },
	},
});

export default function RegUtil() {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					minHeight: "100vh",
					backgroundColor: "black",
				}}>
				<LoginForm />
			</div>
		</ThemeProvider>
	);
}
